import { render } from "./PasswordValidation.vue?vue&type=template&id=72550b55"
import script from "./PasswordValidation.vue?vue&type=script&lang=js"
export * from "./PasswordValidation.vue?vue&type=script&lang=js"

import "./PasswordValidation.vue?vue&type=style&index=0&id=72550b55&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__